module.exports = __webpack_public_path__ + "img/qualification_6.5e17d35e.png";